import router from '@/router/router'
import Store from '@/store/store'
import collector from '@/utils/collector'
import { assembleRoutes } from '@/utils/assembly'
import { MessageBox } from 'element-ui';
import {getUserInfos} from "@/utils/userInfos";
import request from "@/utils/request";
import {check} from "@/utils/checkData";
import md5 from "js-md5";
import {Message} from 'element-ui';
import Cookie from 'js-cookie'
import CryptoJS from "crypto-js";

// 一开始就组装 为了刷新时不掉路由
// 存在token才会拉取路由
assembleRoutes();

router.beforeEach((to, from, next) => {
    // 设置params
    collector.deal(to, from);
    Store.commit('SET_ROUTE', to);

    // 以防浏览器地址栏输入字母大写导致路由导航判断错误
    let toPath = to.path.toLowerCase();
    let userInfo = getUserInfos()
    if (toPath != '/login') {
        if (!userInfo) {
            next({
                path: '/login'
            });
        }
        if (Store.getters.token) {

            if (to.fullPath == '/' && to.name != '') {
                // 解决如果没有权限的情况下，编程式导航用name的形式跳转没有去到404页面的问题
                dialog();
                return;

                // next({
                //     path: '/notFound'
                // })
            } else {
                if (to.name == 'expertList') {
                    // 专家库安全密码验证
                    if (userInfo.id != 1) {
                        expertPwdCheck(next)
                    } else {
                        next();
                    }
                } else {
                    next();
                }

            }
        } else {
            next({
                path: '/login'
            });
        }
    } else {
        next();
        // if (Store.getters.token){
        //     next({
        //         path: '/admin/home/HomePage'
        //     });
        // } else {
        //     next();
        // }
    }

});

router.afterEach((to, from) => {
    // 把params存到session
    collector.set(to.params);
});

function expertPwdCheck(next) {
    let params = {
        servername: 'Ruyi_AdminDoctorServices',
        method: 'exportIsPwd',
        params: {},
    };
    request.post('/services/query_service', params).then(res => {
        if (!check(res)) {
            return;
        }
        if (res.data.data.is_pwd) {
            let expert_pwd = localStorage.getItem('expert_pwd')
            let lpwd = expert_pwd ? aesDecrypt(expert_pwd, 'ryw_expert') : null
            if (lpwd) {
                expertPwd(lpwd, next, true)
            } else {
                MessageBox.prompt('请输入专家库安全密码', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputType: 'password',
                    inputErrorMessage: '请输入正确的密码！'
                }).then(({ value }) => {
                    expertPwd(value, next)
                }).catch(() => {
                });
            }

        } else {
            next()
        }
    })
}

function expertPwd(pwd, next, pwd_storege = false) {
    if (!pwd_storege) {
        pwd = md5(pwd)
    }
    let params = {
        servername: 'Ruyi_AdminDoctorServices',
        method: 'exportIsPwd',
        params: {
            'expert_pwd': pwd
        },
    };
    request.post('/services/query_service', params).then(res=>{
        if (!check(res)) {
            setTimeout(function () {
                MessageBox.prompt('请输入专家库安全密码', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputType: 'password',
                    inputErrorMessage: '请输入正确的密码！'
                }).then(({ value }) => {
                    expertPwd(value, next)
                }).catch(() => {
                });
            }, 1200)
            return;
        }
        localStorage.setItem('expert_pwd', aesEncrypt(pwd, 'ryw_expert'))
        next()
    }).catch(res=>{
        // console.log(res)
    })
}

function dialog(){

    let userInfo = getUserInfos()
    let msg = '';

    if (userInfo.group_name) {
        msg = `暂无操作权限，如需更多权限请联系管理员\r\n(${userInfo.group_name}：${userInfo.group_mobile})！`
    } else {
        msg = `暂无操作权限，如需更多权限请联系管理员！`
    }

    MessageBox.confirm( msg, '权限不足', {
        confirmButtonText: '确定',
        type: 'warning',
        center: true
    }).then(() => {

    }).catch(() => {

    });

}

//加密
function aesEncrypt(plaintext, key) {
    return CryptoJS.AES.encrypt(plaintext, key).toString();
}
//解密
function aesDecrypt(ciphertext, key) {
    let bytes = CryptoJS.AES.decrypt(ciphertext, key);
    return bytes.toString(CryptoJS.enc.Utf8);
}

export default router